import { DocumentSnapshot, TimeStampClass } from "../types/firebase.types";

export const injectMetadataToSnapshotData = (snapshot: DocumentSnapshot) => ({
  ...snapshot.data(),
  id: snapshot.id,
  ref: snapshot.ref,
  snapshot,
});

export const convertObjectTimestampFieldToDate = (object: Record<string, any>) => {
  return Object.entries(object).reduce((modifiedObject, entry) => {
    if (!(entry[1] instanceof TimeStampClass))
      return {
        ...modifiedObject,
        [entry[0]]: entry[1],
      };
    return {
      ...modifiedObject,
      [entry[0]]: entry[1].toDate(),
    };
  }, {});
};
